{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome-extensie niet geïnstalleerd.",
      "CTA": "Extensie installeren"
    },
    "TABS": {
      "PHONE": "Telefoon",
      "SMS": "SMS",
      "HISTORY": "Geschiedenis"
    },
    "HISTORY": {
      "OPEN": "Open",
      "RECENT": "Recent",
      "MISSED": "Gemist",
      "LOADING": "Oproepen laden...",
      "EMPTY": "Geen oproepen hier",
      "ERROR": "Kon de oproepen niet laden",
      "CALL": "Terugbellen",
      "CALL_STATUS": {
        "BUTTON": "Oproepstatus instellen",
        "TITLE": "Oproepstatus",
        "SEARCH_PLACEHOLDER": "Statussen zoeken...",
        "LOADING": "Statussen laden...",
        "NO_OPTIONS": "Er zijn geen oproepstatussen geconfigureerd",
        "NO_MATCH": "Geen overeenkomende status",
        "OPTIONS_ERROR": "Kon de statussen niet laden",
        "RETRY": "Opnieuw proberen",
        "CONFIRM_QUESTION": "„{status}” instellen en het gesprek oplossen?",
        "CONFIRM": "Bevestigen",
        "BACK": "Terug",
        "CANCEL": "Annuleren",
        "SAVING": "Opslaan...",
        "SAVE_ERROR": "Kon de status niet opslaan",
        "RESOLVE_ERROR": "Status opgeslagen, maar het gesprek kon niet worden opgelost"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Telefoonnummer, bijv. +421903000000",
      "BODY_PLACEHOLDER": "Typ je bericht...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Sms versturen",
      "SENDING": "Bezig met versturen...",
      "SENT": "Sms verstuurd",
      "LOADING": "Sms-inboxen laden...",
      "NO_INBOX": "Dit account heeft geen sms-inbox, dus er kan geen sms worden verstuurd.",
      "INVALID_NUMBER": "Voer het nummer in internationale notatie in, inclusief de + aan het begin.",
      "ERROR": "De sms kon niet worden verstuurd. Probeer het opnieuw."
    },
    "ACTIONS": {
      "CONNECT": "Verbinden",
      "GO_TO_TAB": "Ga naar dat tabblad",
      "DISCONNECT": "Verbinding verbreken",
      "ANSWER": "Beantwoorden",
      "HANGUP": "Ophangen",
      "HOLD": "In de wacht",
      "MUTE": "Microfoon dempen",
      "SILENCE": "Audio dempen",
      "TRANSFER": "Doorverbinden",
      "COMPLETE_TRANSFER": "Doorverbinding voltooien",
      "RETURN_TO_CALLER": "Terug naar beller",
      "CANCEL_TRANSFER": "Doorverbinding annuleren",
      "DIALPAD": "Kiestoetsen tonen",
      "OPEN_CONVERSATION": "Gesprek openen"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Inkomende oproep",
      "INCOMING_CALL_FROM": "Inkomende oproep van {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Inkomende oproep van {number}",
      "ANSWER": "Beantwoorden",
      "DECLINE": "Weigeren"
    },
    "TRANSFER": {
      "TITLE": "Oproep doorverbinden",
      "PLACEHOLDER": "Voer het doorverbindnummer in...",
      "SEARCH_PLACEHOLDER": "Agenten zoeken...",
      "TARGET_PLACEHOLDER": "Geselecteerd doorverbinddoel",
      "CONFIRM": "Doorverbinden",
      "MODE_DIRECT": "Nu doorverbinden",
      "MODE_CONSULT": "Eerst agent bellen",
      "CANCEL": "Annuleren"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Weet je zeker dat je pauze wilt nemen voor alle wachtrijen?",
      "CONFIRM_READY": "Weet je zeker dat je terug wilt naar de status 'gereed' voor alle wachtrijen?",
      "CONFIRM_BREAK_QUEUE": "Weet je zeker dat je wilt uitloggen bij de wachtrij {queue}?",
      "CONFIRM_READY_QUEUE": "Weet je zeker dat je wilt inloggen bij de wachtrij {queue}?",
      "LOGIN_TO_QUEUE": "Inloggen",
      "LOGOUT_FROM_QUEUE": "Uitloggen",
      "LOGIN_TO_ALL_QUEUES": "Inloggen bij alle wachtrijen",
      "LOGOUT_FROM_ALL_QUEUES": "Uitloggen bij alle wachtrijen",
      "OPTION_LOGOUT": "Uitloggen",
      "OPTION_BREAK": "Pauze",
      "OPTION_LUNCH": "Lunch",
      "OPTION_AWAY": "Afwezig",
      "OPTION_DO_NOT_DISTURB": "Niet storen",
      "OPTION_BUSINESS_TRIP": "Zakenreis",
      "CONFIRM": "Bevestigen",
      "CANCEL": "Annuleren"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Geen verbinding met het telefoonsysteem",
      "MESSAGE": "Je internetverbinding lijkt niet te werken. Controleer deze en probeer het opnieuw.",
      "CREDENTIALS_TITLE": "Het telefoonsysteem heeft je inloggegevens geweigerd",
      "CREDENTIALS_MESSAGE": "Het telefoonsysteem heeft de gebruikersnaam of het wachtwoord uit je profiel geweigerd. Controleer deze in Profielinstellingen, of neem contact op met je beheerder.",
      "CONFIGURATION_TITLE": "Telefooninstellingen zijn ongeldig",
      "CONFIGURATION_MESSAGE": "De SIP-gebruikersnaam of het serveradres heeft geen geldige indeling, waardoor de telefoon geen verbinding kan maken. Herstel dit in Profielinstellingen.",
      "NETWORK_SHORT": "Verbinding mislukt",
      "CREDENTIALS_SHORT": "Inloggegevens geweigerd",
      "CONFIGURATION_SHORT": "Ongeldige telefooninstellingen",
      "RETRY": "Opnieuw proberen",
      "DISMISS": "Annuleren"
    },
    "CONNECTION_QUALITY": "Verbindingskwaliteit",
    "CONNECTION_QUALITY_EXCELLENT": "Uitstekend",
    "CONNECTION_QUALITY_GOOD": "Goed",
    "CONNECTION_QUALITY_FAIR": "Redelijk",
    "CONNECTION_QUALITY_POOR": "Slecht",
    "CONNECTION_QUALITY_DISCONNECTED": "Verbroken",
    "STATUS": {
      "OFFLINE": "Telefoon offline",
      "IN_OTHER_TAB": "Telefoon verbonden in een ander tabblad",
      "CONNECTING": "Verbinden...",
      "DISCONNECTING": "Verbinding verbreken...",
      "ONLINE": "Telefoon online",
      "DIALING": "Bezig met bellen",
      "TRANSFERRING": "Doorverbinden...",
      "CONSULTING": "In gesprek met agent",
      "CALLER_ON_HOLD": "Beller staat in de wacht",
      "BUSY": "Bezet",
      "DND": "DND",
      "UNAVAILABLE": "Niet beschikbaar",
      "REJECTED": "Oproep geweigerd",
      "CALL_FAILED": "Oproep mislukt"
    },
    "QUEUES": {
      "MORE": "Meer wachtrijen"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Bezig met bellen naar {number}… Je kunt dit tabblad sluiten.",
    "NO_NUMBER": "Geen nummer opgegeven. Gebruik ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Voer telefoonnummer in...",
    "ACTIONS": {
      "DIAL": "Nummer bellen",
      "DIAL_FROM": "Kies het nummer waarmee je belt"
    },
    "DIAL_FROM": {
      "TITLE": "Bellen vanaf het nummer van een inbox"
    },
    "VALIDATION": {
      "REQUIRED": "Telefoonnummer is verplicht",
      "INVALID_FORMAT": "Ongeldige notatie voor telefoonnummer"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Audio-instellingen en testen",
    "SELECT_DEVICE": "Selecteer apparaat...",
    "SYSTEM_DEFAULT": "Systeemstandaard",
    "SAVED": "Opgeslagen",
    "DISCONNECTED_SUFFIX": "niet verbonden",
    "DEVICE_DISCONNECTED": "Het geselecteerde apparaat is niet verbonden. Gesprekken gebruiken de systeemstandaard totdat het weer beschikbaar is.",
    "MICROPHONE": {
      "TITLE": "Microfoon",
      "START_TEST": "Microfoon testen",
      "STOP_TEST": "Test stoppen",
      "LEVEL": "Niveau:",
      "VERDICT": {
        "LISTENING": "Zeg iets in de microfoon…",
        "SILENT": "Je bent niet te horen. Controleer of de microfoon aan staat en de juiste is geselecteerd.",
        "LOW": "Je bent maar zachtjes te horen. Kies een andere microfoon of pas het ingangsvolume aan in je systeeminstellingen.",
        "GOOD": "Goed geluid — je bent goed te horen."
      }
    },
    "SPEAKER": {
      "TITLE": "Luidspreker",
      "TEST": "Luidspreker testen",
      "TESTING": "Bezig met testen...",
      "VOLUME": "Volume:",
      "USING_DEFAULT": "Geselecteerde uitvoer is niet beschikbaar — afgespeeld via de systeemstandaard."
    },
    "DONE": "Gereed",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Fout bij toegang tot de microfoon. Controleer de machtigingen.",
      "MICROPHONE_PERMISSION_DENIED": "Toegang tot de microfoon is geblokkeerd. Sta dit toe in de site-instellingen van je browser om te kunnen bellen.",
      "MICROPHONE_SILENT": "Je microfoon neemt geen geluid op. Controleer je audio-instellingen.",
      "EXTENSION_REQUIRED": "Telefoonextensie niet gevonden. Installeer of schakel deze in om de microfoon te gebruiken.",
      "SPEAKER_TEST": "Fout bij het testen van de luidsprekeruitvoer."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Bezig"
  },
  "QUEUE_STATUS": {
    "READY": "Gereed",
    "NOT_READY": "Accepteert geen oproepen",
    "WRAP_UP": "Afronden",
    "BREAK": "Pauze",
    "LUNCH": "Lunch",
    "AWAY": "Afwezig",
    "DO_NOT_DISTURB": "Niet storen",
    "BUSINESS_TRIP": "Zakenreis",
    "OTHER_CALL": "Ander gesprek",
    "QUEUE_CALL": "Wachtrijoproep",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Geen telefoon",
    "PARTIALLY_READY": "Gedeeltelijk gereed",
    "MIXED": "Gemengd",
    "CHAT_ONLINE": "Online (chat)",
    "CHAT_BUSY": "Bezig (chat)",
    "CHAT_OFFLINE": "Offline (chat)"
  }
}
